import { connect } from 'react-redux';
import * as metaSelectors from 'redux-modules/meta/selectors.js';
import GroupInformation from './GroupInformation';
import * as uiStateSelectors from 'redux-modules/uiState/selectors.js';

function mapStateToProps(state) {
  return {
    language: uiStateSelectors.selectResumeLanguage(state),
    meta: metaSelectors.selectResumeMeta(state)
  };
}

export default connect(mapStateToProps, null)(GroupInformation);
